import type React from "react";

import { create } from "zustand";

export type AlertType = "info" | "warning" | "success" | "loading";

interface AlertProps {
  type?: AlertType;
  title?: string;
  description?: string | React.ReactNode;
  descriptionSrOnly?: boolean;
  actionLabel?: string;
  cancelLabel?: string;
  onAction?: () => void;
  onCancel?: () => void;
  preventEscapeKeyDown?: boolean;
  maxWidth?: string;
  overlayClassName?: string;
}

interface AlertState {
  open: boolean;
  props: AlertProps;
  openDialog: (props: AlertProps) => void;
  closeDialog: () => void;
}

export const useAlertStore = create<AlertState>(set => ({
  open: false,
  props: {},
  openDialog: props => set({ open: true, props }),
  closeDialog: () => {
    set({ open: false });
    setTimeout(() => {
      set(state => {
        if (!state.open) {
          return { props: {} };
        }
        return {};
      });
    }, 300);
  },
}));
